<template>
  <onboarding-section :animate-leave="animateLeave">
    <template #right>
      <div :class="[$style.right__wrapper, $style.right__wrapper_upshifted]">
        <div
          :class="[
            $style.select__wrapper,
            animateEnter && !animateLeave ? $style.animateEnter : '',
            animateLeave && !animateEnter ? $style.animateLeave : '',
          ]"
        >
          <div
            v-for="item in industryItems"
            :id="`gp_autotest_registration_industry_step_selectItem_${item.value}`"
            :key="item.value"
            :class="$style.item__wrapper"
            @click="handleItemClick(item.value)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
        <portal
          to="onboarding-footer"
        >
          <vgp-button
            id="gp_autotest_registration_industry_step_submit_button"
            :class="[
              $style.submit_button,
              animateEnter && !animateLeave ? $style.animateEnter : '',
              animateLeave && !animateEnter ? $style.animateLeave : '',
            ]"
            type="text-green"
            :label="locales('onboarding_skip_step_btn_label')"
            small
            @onClick="nextStep(true)"
          />
        </portal>
      </div>
    </template>
  </onboarding-section>
</template>

<script>
import OnboardingSection from '../OnboardingSection.vue';
import profile from '../../../../models/profile';
import constants from '../../../../helpers/constants';
import { mapState } from 'vuex';
import  rights from '../../../../components/rights/index';
import { ANALYTIC_ACTIONS } from '../../onboarding.config';

export default {
  name: 'IndustryInfo',
  components: {
    OnboardingSection,
  },
  data() {
    return {
      locales: __,
      animateEnter: false,
      animateLeave: false,
    };
  },
  computed: {
    ...mapState('onboarding', ['analyticType', 'activeStepId']),
    industryItems() {
      return constants.INDUSTRIES.map(industry => {
        const [value, label] = Object.entries(industry).flat();
        return { value, label: __(label) };
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.animateEnter = true;
    }, 0);
  },
  methods: {
    handleItemClick(value) {
      this.nextStep();
      profile.saveSettings({ user_industry: value });
    },
    nextStep(isSkip = false) {
      if (this.animateLeave) {
        return;
      }

      if (rights.account.isOwner()) {
        userExtAnalytics.log('onboarding', { type: this.analyticType, step: this.activeStepId, action: ANALYTIC_ACTIONS.DONE });
        if (isSkip) {
          userExtAnalytics.log('onboarding', { type: this.analyticType, step: this.activeStepId, action: ANALYTIC_ACTIONS.SKIP });
        }
      }

      this.animateEnter = false;
      this.animateLeave = true;
      setTimeout(() => {
        this.$store.dispatch('onboarding/nextStep');
      }, 750);
    },
  },
};
</script>

<style lang="less" module>
@import "../../../../less/_variables.less";

.right__wrapper {
  width: 364px;
  
  &_upshifted {
    position: relative;
    top: -60px;
  }
}

.select__wrapper {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity .2s, transform .2s cubic-bezier(0, 0, 0.58, 1);

  display: flex;
  flex-direction: column;
  gap: 7px;
  max-width: 301px;

  &.animateLeave {
    transition: opacity .25s, transform .25s cubic-bezier(0.42, 0, 1, 1);
    transition-delay: .2s;
    opacity: 0;
    transform: translateY(-40px);
  }

  &.animateEnter {
    opacity: 1;
    transform: translateY(0);
  }
}

.item__wrapper {
  width: 100%;
  transition: all .3s ease;
  font-family: Lato-Bold, sans-serif;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;
  text-align: left;

  padding: 7px 24px;

  color: #586972;

  background: #E3E8EC;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
    background: #337870;
    box-shadow: 0 6px 11px rgba(0, 86, 76, 0.35);
    color: @white;
  }

  &:active {
    box-shadow: none;
  }
}

.submit_button {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity .2s, transform .2s cubic-bezier(0, 0, 0.58, 1);

  &.animateLeave {
    transition: opacity .2s, transform .2s cubic-bezier(0.42, 0, 1, 1);
    transition-delay: .3s;
    opacity: 0;
    transform: translateY(-40px);
  }

  &.animateEnter {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
